<div class="property-description-page__grid-container">
    <h1 class="property-description-page__title">About your property</h1>
    <property-listing-title-section
        class="property-description-page__listing-title-section"
    >
    </property-listing-title-section>
    <property-about-section class="property-description-page__about-section">
    </property-about-section>
    <property-side-card
        class="property-description-page__side-card-section"
        [icon]="sideCardIcon"
        [heading]="sideCardHeading"
        [callToActionText]="sideCardCallToActionText"
        [callToActionLink]="sideCardCallToActionLink"
    >
        Get the latest news, resources and more about Trade Me products.
    </property-side-card>

    <property-sale-attribute-section
        class="property-description-page__attribute-section"
    >
    </property-sale-attribute-section>
    <property-agency-reference-section
        class="property-description-page__agency-reference-section"
    >
    </property-agency-reference-section>
</div>
